import LogoButton from '../../../components/Assets/LogoButton';
import Badge from '../../../components/badge';

import {
  BadgeBackgroundColorEnum,
  BadgeContentEnum,
  BadgeTextColorEnum,
} from '../../../components/badge/enums';
import useAuth from '../../auth/useAuth';
import FolderLineIcon from './ForlderLineIcon';

export interface IFolderLineProps {
  folder: IFolder;
  activeFolder: IFolder | null;
  onFolderUpdate: (folder: IFolder) => void;
  onFolderDelete?: (folder: IFolder) => void;
  onActiveFolder?: (folder: IFolder) => void;
}
function FolderLine({
  folder,
  activeFolder,
  onFolderUpdate,
  onFolderDelete,
  onActiveFolder,
}: IFolderLineProps) {
  const { userIdIri } = useAuth({});

  if (!folder) return null;

  const isOwner = folder?.owner.idIri === userIdIri;

  return (
    <tr
      className={
        folder?.isDefault ? 'my-folders-content default' : 'my-folders-content'
      }
    >
      <td>
        <FolderLineIcon
          folder={folder}
          isActive={activeFolder?.idIri === folder?.idIri}
        />
      </td>
      <td className="my-folders-desktop">
        {folder.hasUpdates && (
          <Badge
            badgeContent={BadgeContentEnum.MISE_A_JOUR}
            bgColor={BadgeBackgroundColorEnum.GREEN}
            textColor={
              folder.isDefault ? BadgeTextColorEnum.VIOLET : BadgeTextColorEnum.WHITE
            }
            isMini
          />
        )}
      </td>
      {folder?.isDefault ? (
        <td>Par défaut</td>
      ) : (
        <td className="my-folders-desktop">{`${
          folder?.totalCollaborators
        } collaborateur${folder.totalCollaborators > 1 ? 's' : ''}`}</td>
      )}
      <td className="my-folders-desktop">
        <Badge
          badgeDynamicContent={`${folder?.totalAdStudies} annonces`}
          bgColor={
            folder?.isDefault
              ? BadgeBackgroundColorEnum.VIOLET
              : BadgeBackgroundColorEnum.GREY
          }
          textColor={
            folder?.isDefault
              ? BadgeTextColorEnum.WHITE
              : BadgeTextColorEnum.DARKER_GREY
          }
          isMini
        />
      </td>
      <td className="my-folders-mobile">
        <LogoButton
          btnType="button"
          handleClick={() => onActiveFolder?.(folder)}
          btnLogo="threePoints"
          tooltip={`Actions`}
        />
      </td>
      <td className="my-folders-desktop">
        {isOwner && !folder?.isDefault && (
          <div className="my-folders-actions">
            <LogoButton
              btnType="button"
              handleClick={() => onFolderUpdate(folder)}
              btnLogo="pen-violet"
              tooltip="Modifier"
            />
            <LogoButton
              btnType="button"
              handleClick={() => onFolderDelete?.(folder)}
              btnLogo="delete-red"
              tooltip={`Supprimer`}
            />
          </div>
        )}
      </td>
    </tr>
  );
}

export default FolderLine;
